import { render, staticRenderFns } from "./ParentSection.vue?vue&type=template&id=5d91d89f&scoped=true&"
import script from "./ParentSection.vue?vue&type=script&lang=js&"
export * from "./ParentSection.vue?vue&type=script&lang=js&"
import style0 from "./ParentSection.vue?vue&type=style&index=0&id=5d91d89f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d91d89f",
  null
  
)

export default component.exports